import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { ListNamesDictionary, getDeployedMerchantRules } from 'Services';
import { RQ_DEPLOYED_MERCHANT_RULES } from 'Utils';
import { transformServerData } from '../helper';

type UseDeployedMerchantRulesProps = {
    merchantId: string;
    version?: number;
    enabled?: boolean;
    listNameMap?: ListNamesDictionary;
    parameterData?: UseGetParametersResponse;
};

function useDeployedMerchantRules({
    merchantId,
    version,
    enabled,
    listNameMap,
    parameterData
}: UseDeployedMerchantRulesProps) {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_DEPLOYED_MERCHANT_RULES, templateRepositoryId, merchantId, version],
        () => getDeployedMerchantRules(templateRepositoryId!, merchantId, version),
        {
            enabled: enabled !== false && !!(templateRepositoryId && templateRepositoryId > 0),
            select: transformServerData({ t, listNameMap, parameterData })
        }
    );
}

export default useDeployedMerchantRules;
